const en = {
  10000001: 'SuperEx 2nd Anniversary Celebration',
  10000002: 'Sign in for great rewards!',
  10000003: 'According to the number of participants, the larger the number of participants, the larger the prize pool will be unlocked, up to 10,000USDT. ',
  10000004: 'SuperEx 2nd Anniversary',
  10000005: 'Futures Championship Win 20,000 USDT',
  10000006: 'Trading Volume Ranking Competition: Unlock the highest prize of <span style="color: #ffc72b;">10,000</span> USDT bonus pool. ',
  10000007: 'Futures Championship',
  10000008: 'Futures Championship Win 20,000 USDT',

  10000009: 'Select',
  10000010: 'Total supply',
  10000011: 'Explorer',
  10000012: 'Return',
  10000013: 'Next',
  10000014: 'Previous',
  10000015: 'Fill in the information',
  10000016: 'Please enter the Token Name',
  10000017: 'Please enter the full name of the token.',
  10000018: 'Got It',
  10000019: 'Please enter the instance name.',
  10000020: 'Please provide the circulating supply',
  10000021: 'Done',
  10000022: 'After that, you can view the statistical data of the trading pair on the Free Market page of the website.',
  10000023: '{currency} listed on Exchange !',
  10000024: 'Year',
  10000025: 'Month',
  10000026: 'Day',

  8000067: 'Statistics',
  8000068: 'Token Name',
  8000069: 'Main chain or Protocol',
  8000070: 'Contract address or Ticker',
  8000071: 'Instance Name',
  8000072: 'Instance Creation Time',
  8000073: 'Instance Status',
  8000074: 'Commission Amount (Cumulative)/U',
  8000075: 'Commission Amount (Last Week)/U',
  8000076: 'Transaction Amount (Last Week)/U',
  8000077: 'Number of Transactions (Last Week)',
  8000078: 'Create a trading pair',
  8000079: 'Extension',
  8000080: 'Listed',
  8000081: 'To Be Delisted',
  8000082: 'Delisted',
  8000083: 'Select the token',
  8000084: 'Listing notification',
  8000085: 'Creation successful',
  8000086: 'Listing in the Free Market',
  8000087: 'At SuperEx, you can easily and for free complete exchange listings, and have the opportunity to receive up to 80% of trading fee dividends.',
  8000088: 'How it works?',
  8000089: 'Create a New Trading Pair',
  8000090: 'I’m going to list the coin',
  8000091: 'Create a Trading Pair‘s Instance',
  8000092: 'SuperEx Exchange',
  8000093: 'Why choose us?',
  8000094: 'Diverse Choices',
  8000095: 'Supports multiple chains of ETH, SOL and BSC.',
  8000096: 'Immediate listing without manual verify like decentralized process, and enjoy the convenience of Order Book Trading.',
  8000097: 'API Supported',
  8000098: 'You can use the API interface to conduct market making or trading, making your operations more efficient and automated.',
  8000099: 'Exposure and Traffic',
  8000100: 'By listing in Free Market, enjoy the massive user traffic of SuperEx and gain more attention.',
  8000101: 'Whether you are a novice or an experienced trader, our Free Market will bring you new experiences and investment opportunities. Create your own trading pairs immediately, promote your favorite  coins, and enjoy the commission income from trading fees!',
  8000102: 'Your total assets must exceed {resultData} USDT before you are eligible to create a trading pair.',
  8000103: 'Listing Your Favourite Token',
  8000104: 'You may select your preferred cryptocurrency and pair it with USDT to create a unique trading pair.',
  8000105: 'Receiving fee Commission',
  8000106: 'When the trading volume of a Trading Pair Instance you created reaches a certain threshold, a portion of the transaction fees will be returned to you as a commission. This allows you, as the creator of the Trading Pair Instance, to also share in the trading profits.',
  8000107: 'Now you are a restricted user and are temporarily unable to create new trading pairs. Please try again tomorrow.',
  8000108: 'Please select a language',
  8000109: 'White Paper',
  8000110: 'The token has been banned from being listed!',
  8000111: 'This token is already listed in the SuperEx Main Market and you cannot create another trading pair!',
  8000112: 'Please enter a valid contract address / Ticker!',
  8000113: 'Your Main Market ET balance is insufficient. To create a new trading pair instance, you need to pay a management fee of {num} ET. Please recharge and try again.',
  8000114: 'You have made too many incorrect inputs during the process of creating a new trading pair today. Therefore, you are not able to submit any more requests today. Please try again tomorrow.',
  8000115: 'The token already exists, so now we will create a new Instance of the trading pair for you!',
  8000116: 'Please confirm the following information:',
  8000117: 'Decimal length of the token quantity',
  8000118: 'How to freely list a coin',
  8000119: 'Token full name',
  8000120: 'Decimal length of the token price',
  8000121: 'SUPEREX Coin Listing: <em class="normal" style="color: #0CAA6D;"> 0 Listing Fees! </em><em class="normal" style="color: #1D90F5;"> 0 Communication Costs! </em> Complete exchange listing in 1 minute and enjoy up to <em class="normal" style="color: #F65D62;">80% profit sharing.</em>',
  8000122: 'Token introduction in English',
  8000123: 'The following information is required:',
  8000124: 'The instance name you entered already exists. Please enter a different one.',
  8000125: 'The following are optional information:',
  8000126: 'Please choose the main chain or protocol, and the corresponding management fee.',
  8000127: 'Step 1: Copy and paste the contract address of the new coin.',
  8000128: 'Please enter the contract address / Ticker.',
  8000129: 'Confirm',
  8000130: 'Your instance of the trading pair {currency} has been successfully created!',
  8000131: 'Step 2: If this coin is listing on our exchange for the first time, you need to complete several basic details, such as coin introduction and uploading logo image.',
  8000132: 'BTC Protocol Markets',
  8000133: 'Step 3: You only need to name the instance of this trading pair you’ve created. Then, the listing process is complete, and the coin can be traded publicly.',
  8000134: 'List Tokens',
  8000135: 'Please enter the total supply.',
  8000136: 'Step 4: Once the weekly trading volume of your instance reaches a threshold, you will receive a share of the trading fees from the instance.',
  8000137: 'If you choose 2, it means that the numerical display of your token price is accurate to 0.01. For example, the price of BTC is displayed as $72156.78. For most  tokens, we recommend choosing 11.',
  8000138: 'Please enter',
  8000139: 'I’m going to start listing the coin.',
  8000140: 'Please enter a brief description of the token in English.',
  8000141: 'You can simply understand ‘instance’ as multiple versions of the same trading pair, with one of those versions being the instance you created. Other users distinguish these versions by the instance name. As long as users choose your instance for trading, you have the opportunity to receive corresponding fee dividends.',
  8000142: 'The email format is incorrect.',
  8000143: 'Please enter the blockchain query address.',
  8000144: 'Circulating Supply',
  8000145: 'The circulating supply is limited to 1-20 digits as a positive integer.',
  8000146: 'Token Icon',
  8000147: 'Supports PNG or JPG format, file size limit is 5 MB, and you can upload up to 10 times per day.',
  8000148: 'Issue Date',
  8000149: 'Please select the issue date.',
  8000150: 'Please provide the link to the white paper.',
  8000151: 'Official Website',
  8000152: 'Please provide the official website link.',
  8000153: 'Free Market Listing',
  8000154: 'Getting your token listed on Exchange',
  8000155: 'The input limit for the Token Name is 9 characters, and only numbers, English letters, and English symbols are supported',
  8000156: 'The input limit for the token full name is 50 characters, and only numbers, spaces, English letters, and English symbols are supported.',
  8000157: 'The total supply should be a positive integer with 1 to 20 digits.',
  8000158: 'Supports various languages, punctuation, numbers, and spaces. The first or last character cannot be a space, and there cannot be consecutive spaces',
  8000159: '1. The issuer is responsible for the authenticity of the information, and the platform reserves the right to delist tokens or trading pair instance at any time and adjust the information content at any time.',
  8000160: '2. The issuer is required to conduct thorough research on the listed token and be responsible for its reasonableness, compliance, and legality. If the platform detects any malicious or harmful or other specific behavior or content in the token\'s smart contract, it will delist the token directly and represent users in claiming against the issuer.',
  8000161: '3. If the issuer or anyone else wishes to make adjustments to the token information later on, they need to contact our customer service.',
  8000162: '4. To protect the interests of users and eliminate poor-quality tokens, if the trading pair instance created by the issuer do not meet our platform\'s trading activity requirements, the issuer will be notified of delisting approximately one week later. Every Monday, the platform will send delisting notifications through emails and App Notifiications for non-compliant instances to the issuers. And the issuers will have the opportunity to apply for Listing Extension within 5 days. If the application is successful, an additional 4 weeks of observation time will be granted; otherwise, the instances will be delisted.',
  8000163: '5. If the trading pair instance created by the token issuer meets the platform’s dividend threshold for trading volume, they will receive the corresponding fee dividends.',
  8000164: 'Are you willing to provide a certain amount of tokens for operational activities and marketing to expand the influence of the coin?',
  8000165: '6. The issuer can contact our customer service to apply for Market Maker.',
  8000166: 'Create',
  8000167: 'You are about to create an instance of the trading pair {currency} and deduct {upFee} ET from your Main Market account.',
  8000168: 'No',
  8000169: 'Yes',
  8000170: 'Please enter your email address.',
  8000171: 'Do you have a referee or contact person?',
  8000172: 'Please enter the name or contact information.',
  8000173: 'By clicking this checkbox, you acknowledge all risks involved and agree to our <a id="service_href" class="pointer" style="color: #D9A31A;text-decoration: underline" target="_self">Terms and Conditions</a>.',
  8000174: 'Gain from listing',
  8000175: 'The right to list on an exchange',
  8000176: 'The token is not supported for listing now！',
  8000177: 'Fill in the information',
  8000178: 'Go Share',
  8000179: 'listed on Exchange!',
  8000180: 'SuperEx Free Market, a crypto world of the users, by the users, for the users',
  8000181: 'I have created a trading pair {symbol} on SuperEx! To the Moon!',
  8000182: 'The dividend amount for each transaction is updated on Monday, but there may be a delay of up to 3 business days during the actual distribution process. You can check the relevant records under "Wallet History" - "Others" - "Main Market" through the "Send Rewards" type.',
  8000183: 'Twitter Account',
  8000184: 'Telegram Account',
  8000185: 'Discord Account',
  8000186: 'Please enter a valid Twitter link!',
  8000187: 'Please enter a valid Telegram link!',
  8000188: 'Please enter a valid Discord link!',
  8000189: 'Please enter the Twitter link',
  8000190: 'Please enter the Telegram link',
  8000191: 'Please enter the Discord link',
  8000192: 'Sorry, the content or related permission settings of the smart contract for this currency have high security risks. Please try using another currency.',
  8000193: 'Sorry, the content of the smart contract for this currency may have potential risks. Currently, it cannot be listed. Please try using another currency.',
  8000194: 'Note:',
  8000195: 'You need to complete the deposit for this token before you can place a sell order.',
  8000196: 'You need to transfer USDT to the Free Market Account before you can place a buy order.',
  8000197: 'You need to connect the API before you can engage in market-making trading.',
}
export default en



// WEBPACK FOOTER //
// ./src/i18n/langs/languageGaea/en.js